import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {Match} from '../../../../../model/events/Match';
import {environment} from '../../../../../../environments/environment';
import { TabView, TabViewModule } from 'primeng/tabview';
import {MatchResultPipe} from '../../../../../pipes/match-result.pipe';
import {MatchDialogHeaderComponent} from './match-dialog-header/match-dialog-header.component';
import { PrimeTemplate } from 'primeng/api';
import { EventMatchReportComponent } from './event-match-report/event-match-report.component';
import { EventMatchDetailsInfoComponent } from './event-match-details-info/event-match-details-info.component';
import { SpielPerformancesComponent } from '../../../../shared/spiel/spiel-performances/spiel-performances.component';
import { TooltipModule } from 'primeng/tooltip';
import { StatisticMatchDetailsComponent } from '../../../../shared/spiel/statistic-match-details/statistic-match-details.component';
import { SpielSpielverlaufComponent } from '../../../../shared/spiel/spiel-spielverlauf/spiel-spielverlauf.component';
import {StatisticMatch} from '../../../../player/model/statistic-match';
import {DialogHelper} from '../../../../shared/helper/dialog-helper';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {FrontendService} from '../../../../../services/frontend.service';

export const MATCH_DETAILS_TAB_INFO = 'INFO';
export const MATCH_DETAILS_TAB_PERFORMANCES = 'PERFORMANCES';
export const MATCH_DETAILS_TAB_STATISTICS = 'STATISTICS';
export const MATCH_DETAILS_TAB_REPORT = 'REPORT';
export const MATCH_DETAILS_TAB_DARTS_SCORER = 'DARTSSCORER';

@Component({
    selector: 'app-event-match-details',
    templateUrl: './event-match-details.component.html',
    styleUrls: ['./event-match-details.component.scss'],
    standalone: true,
    imports: [TabViewModule, PrimeTemplate, EventMatchReportComponent, EventMatchDetailsInfoComponent, SpielPerformancesComponent, TooltipModule, StatisticMatchDetailsComponent, SpielSpielverlaufComponent, TranslatePipe]
})
export class EventMatchDetailsComponent implements OnInit
{
  TAB_INFO = MATCH_DETAILS_TAB_INFO;
  TAB_PERFORMANCES = MATCH_DETAILS_TAB_PERFORMANCES;
  TAB_STATISTICS = MATCH_DETAILS_TAB_STATISTICS;
  TAB_REPORT = MATCH_DETAILS_TAB_REPORT;
  TAB_DARTS_SCORER = MATCH_DETAILS_TAB_DARTS_SCORER;

  configurationData: any;
  databaseId: number;
  refreshView = false;
  firstTabInitialization = true;

  @ViewChild('tabView', {read: TabView}) tabView: TabView;
  match: Match;
  isMobile: boolean;
  selectedTab: string;
  positionTop: number;

  hideStatistics: boolean;

  public static showDialog(dialogService: DialogService, match: Match, selectedTab: string,
                           matchResultPipe: MatchResultPipe, databaseId: number,
                           translate: TranslateService): DynamicDialogRef
  {
    const isMobile = window.innerWidth < environment.mobileSize;
    return dialogService.open(
      EventMatchDetailsComponent,
      {
        header: this.getTitle(match, matchResultPipe, translate),
        templates: {
          header: MatchDialogHeaderComponent
        },
        duplicate: true,  // Gleicher Dialog 2x öffnen
        data:
          {
            selectedTab,
            match,
            readOnly: true,
            databaseId
          },
        width: (window.innerWidth < environment.mobileSize) ? '100%' : environment.mobileSize + 'px',
        dismissableMask: true,
        closable: true,
        modal: true,
        styleClass: 'dynamicDialog bodyFrontend panelNormalHeader customDialogHeader',
        height: isMobile ? '100%' : '90%',
        draggable: true,
        keepInViewport: true,
        resizable: true,
        maximizable: !isMobile
      });
  }

  public static showDialogPlayerProfile(
    dialogService: DialogService, frontendService: FrontendService, restErrorHelper: RestErrorHelper, match: StatisticMatch,
    selectedTab: string): void
  {
    frontendService.getMatchDatabase(match.database, match.matchId).subscribe({
      next: (matchResponse: Match) =>
      {
        console.log('Match gelesen', matchResponse);
        const isMobile = window.innerWidth < environment.mobileSize;
        dialogService.open(
          EventMatchDetailsComponent,
          DialogHelper.createBasicConfig(
            {
              header: '',
              templates: {
                header: MatchDialogHeaderComponent
              },
              data:
                {
                  selectedTab,
                  match: matchResponse,
                  readOnly: true,
                  databaseId: match.database
                },
              width: DialogHelper.getDialogWidth(800),
              styleClass: 'dynamicDialog bodyFrontend panelNormalHeader customDialogHeader',
              height: isMobile ? '100%' : '90%',
            }
          ));
      },
      error: error => restErrorHelper.handleErrorService(error)
    });
  }

  public static getTitle(match: Match, matchResultPipe: MatchResultPipe, translate: TranslateService): string
  {
    let headerStr = translate.instant('MATCH_DETAILS') + ' (' + translate.instant('MATCH_NR', {value: match.gameNr}) + ')';
    if (match.participantHome && match.participantGuest && match.participantHome.displayName && match.participantGuest.displayName)
    {
      headerStr = '#' + match.gameNr + ': ' + match.participantHome.displayName + ' - ' + match.participantGuest.displayName;
      const resultStr = match.matchReport ? matchResultPipe.transform(match, 0, false, true) :
        matchResultPipe.transform(match, 0, false, false);
      if (resultStr)
        headerStr += ' | ' + resultStr;
    }
    console.log('Title: ' + headerStr);
    return headerStr;
  }

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private matchResultPipe: MatchResultPipe,
              private translate: TranslateService)
  {
    if (config.data)
    {
      this.match = config.data.match;
      this.selectedTab = config.data.selectedTab;
      this.databaseId = config.data.databaseId;
      /*this.hideStatistics = this.databaseId === 9 &&
        (this.match?.matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL ||
          this.match?.matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL_DECIDER); // Nur für DLMM, später wieder rausnehmen
      if (this.hideStatistics)
        this.selectedTab = MATCH_DETAILS_TAB_INFO;*/
    }
    this.onResize();
  }

  ngOnInit(): void
  {
    setTimeout(() =>
    {
      this.tabView?.updateInkBar();
    }, 250);

    this.configurationData = {
      readOnly: true,
      participant: null,
      eventId: this.match.eventId,
      match: this.match,
      databaseId: this.databaseId,
      frontend: true
    };
  }

  public onResize(): void
  {
    this.isMobile = window.innerWidth < environment.mobileSize;

    if (this.isMobile)
      this.positionTop = 158;
    else this.positionTop = (window.innerHeight / 10) + 188;
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event): void
  {
    console.log('Back button pressed', event);
    this.ref.close(true);
  }

  public updateTitle(): void
  {
    console.log('updateTitle()');
    this.config.header = EventMatchDetailsComponent.getTitle(this.match, this.matchResultPipe, this.translate);
  }

  public changeTab(tab: string): void
  {
    console.log('changeTab: ' + tab);
    this.firstTabInitialization = false;
    if (tab)
    {
      this.refreshView = true;
      this.selectedTab = tab;

      setTimeout(() => this.refreshView = false, 0);
      // setTimeout(() => this.tabView.updateInkBar(), 1000);
    }
  }
}
